export enum FileStatus {
    COMPLETED = 'completed',
    IN_PROGRESS = 'inProgress',
    WAITING = 'waiting',
    ERROR = 'error',
    CANCELED = 'canceled',
}

export enum FileSource {
    FILE = 'file',
    LINK = 'link',
}
